import React from "react";

import { contact } from "../data";

const ContactUs = () => {
  const { title, office, Workshop, Email, Mob1, Mob2 } = contact;
  return (
    <section className="section bg-newsletter min-h-[490px]" id="contact">
      <div className="container mx-auto flex justify-center  lg:justify-end">
        <div className="w-full max-w-[558px] text-center text-white lg:text-left">
          <h2 className="text-4xl font-semibold max-w-[350px] mx-auto lg:mx-0 mb-5 leading-normal">
            {title}
          </h2>
          <p className="text-xl font-light mb-10">Office : {office}</p>
          <p className="text-xl font-light mb-10">Factory : {Workshop}</p>
          <p className="text-xl font-light mb-10">
            Email :<a href={`mailto:${Email}`}> {Email}</a>
          </p>
          <p className="text-xl font-light mb-5">Enquiry :</p>
          <p className="text-xl font-light mb-5">
            <a href={`tel:${Mob1.call}`}>{Mob1.text}</a>
          </p>
          <p className="text-xl font-light ">
            <a href={`tel:${Mob2.call}`}>{Mob2.text}</a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
